module.exports = __webpack_public_path__ + "assets/img/location-light.80b4d3d1.svg";